import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 9.75a3.016 3.016 0 0 0 -.711 -.466m-3.41 .596a2.993 2.993 0 0 0 -.042 4.197a3.016 3.016 0 0 0 4.163 .173","key":"svg-0"}],["path",{"d":"M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

const IconCopyrightOff = createReactComponent('outline', 'copyright-off', 'CopyrightOff', __iconNode);

export default IconCopyrightOff;